  $(document).ready(function(){
    const dropdownSelector = '.header__nav-item.has-dropdown';
    const navLinkSelector = '.header__nav-link';
    
    $(dropdownSelector).hoverIntent({
      over: function () {
        if ($(this).hasClass('current')) return;
        $(this).addClass('current');
      },
      out: function () {
        $(this).removeClass('current');
      },
      timeout: 750
    });
  
    $(document).on('click', `${dropdownSelector} > ${navLinkSelector}`, function (e) {
      e.preventDefault();
      e.stopPropagation();
  
      const $parentItem = $(this).closest(dropdownSelector);
      const isOpen = $parentItem.hasClass('current');
  
      $(dropdownSelector).removeClass('current');
      if (!isOpen) {
        $parentItem.addClass('current');
      }
    });

  
    $(document).on('click', function () {
      $(dropdownSelector).removeClass('current');
    });

    
  });
 $(document).ready(function(){
   setTimeout(() => {
     $('#shopify-pc__banner').css('display', 'block');
   }, 30000)
 })

$(document).ready(function(){
  const drawerButton = document.querySelector('header-drawer #Navigation-drawer-header .drawer__button');
  drawerButton.addEventListener('click', (event) => {
    // if (event.currentTarget.classList.contains('menu-is-open')) return;
    window.setTimeout(function () { 
      const mobileSearchField = document.getElementById('search-mobile');
      if (!!mobileSearchField) {
        if (document.activeElement) {
          document.activeElement.blur();
        }
        // const touch = new Touch({
        //   identifier: "123",
        //   target: mobileSearchField,
        // });
        // const touchEvent = new TouchEvent("touchstart", {
        //   touches: [touch],
        //   view: window,
        //   cancelable: true,
        //   bubbles: true,
        // });

        // var event1 = new Event('touchstart');
        // var event2 = new Event('touchend'); 
        // mobileSearchField.dispatchEvent(event1); 
        // mobileSearchField.dispatchEvent(event2);

        mobileSearchField.click();
        mobileSearchField.focus();
        // mobileSearchField.dispatchEvent(touchEvent);
      }
    }, 100);
  })
});
